import { CreditorInvoicesEntry } from '../../models/Entities/CashFlow/CreditorInvoice/CreditorInvoice';

export interface CreditorInvoicesState {
  /** Facturas por acreedor (GUID del profesional, en minúsculas). */
  byCreditor: Record<string, CreditorInvoicesEntry>;
  /** Facturas que cubre cada pago (se conoce al abrir o guardar sus facturas). */
  invoiceCountByPayment: Record<number, number>;
}

export const emptyCreditorInvoicesEntry = (): CreditorInvoicesEntry => ({ status: 'idle', data: undefined });

export const CreditorInvoicesUnloadedState: CreditorInvoicesState = {
  byCreditor: {},
  invoiceCountByPayment: {},
};

export const creditorKey = (creditorId: string | null | undefined): string => (creditorId || '').toLowerCase();
